import { render, staticRenderFns } from "./painel_acompanhamento.vue?vue&type=template&id=6607a65b&"
import script from "./painel_acompanhamento.vue?vue&type=script&lang=js&"
export * from "./painel_acompanhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports